import { create } from 'zustand';

import { Transport } from 'mediasoup-client/lib/types';
import { TProducer } from '@src/types';

interface IProducerStore {
  // Producers
  producers: Map<string, TProducer>;
  producerTransport: Transport | null;
  appendProducer: (id: string, producer: TProducer) => void;
  deleteProducer: (id: string) => void;

  // Producers labels
  producerLabel: Map<string, string>;
  appendProducerLabel: (id: string, label: string) => void;
  deleteProducerLabel: (id: string) => void;
  resetStates: () => void;
}

export const useProducersStore = create<IProducerStore>((set) => ({
  producers: new Map(),
  producerTransport: null,
  appendProducer: (id, producer) =>
    set((state) => {
      const updatedProducers = new Map(state.producers);
      updatedProducers.set(id, producer);
      return { ...state, producers: updatedProducers };
    }),
  deleteProducer: (id) =>
    set((state) => {
      const updatedProducers = new Map(state.producers);
      updatedProducers.delete(id);

      return { ...state, producers: updatedProducers };
    }),

  producerLabel: new Map(),
  appendProducerLabel: (id, label) =>
    set((state) => {
      const updatedProducersLabels = new Map(state.producerLabel);
      updatedProducersLabels.set(id, label);
      return { ...state, producerLabel: updatedProducersLabels };
    }),
  deleteProducerLabel: (id) =>
    set((state) => {
      const updatedProducersLabels = new Map(state.producerLabel);
      updatedProducersLabels.delete(id);

      return { ...state, producerLabel: updatedProducersLabels };
    }),
  resetStates: () => set({ producers: new Map(), producerTransport: null, producerLabel: new Map() }),
}));
